module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "builder__actions",
    class: _vm.responsiveCssClasses
  }, [(this.initialQueryString) ? _c('div', {
    staticClass: "builder__reset"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('reset-options-to-initial-query-string')
      }
    }
  }, [_vm._v("Reset")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "builder__clear"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('clear-options')
      }
    }
  }, [_vm._v("Clear")])]), _vm._v(" "), _c('div', {
    staticClass: "builder__download"
  }, [_c('a', {
    attrs: {
      "href": _vm.downloadImageLink,
      "rel": "nofollow noindex"
    }
  }, [_vm._v("Download")])]), _vm._v(" "), (!this.isSoldOut) ? _c('div', {
    staticClass: "builder__add"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isSubmitting
    },
    on: {
      "click": function($event) {
        _vm.$emit('add-to-cart')
      }
    }
  }, [_vm._v("Add to Cart")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7357d0be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions.vue
// module id = 373
// module chunks = 0